import { Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'rl-arrow-buttons',
  templateUrl: './arrow-buttons.component.html',
  styleUrls: ['./arrow-buttons.component.scss']
})
export class ArrowButtonsComponent{

  @Input() dir : 'up' | 'down' | 'right' | 'left';
  @Input() disable : boolean;
  @Output() onClick = new EventEmitter<void>();
  
  constructor() { }

}
